import { LogLevel, PublicClientApplication, type RedirectRequest } from '@azure/msal-browser';
import { msalClientId, msalTenantId } from './env.js';

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: msalClientId,
    authority: `https://login.microsoftonline.com/${msalTenantId || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? LogLevel.Info : LogLevel.Error,
      piiLoggingEnabled: false,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        if (level === LogLevel.Error) {
          console.error(message);
        } else if (level === LogLevel.Warning) {
          console.warn(message);
        }
      },
    },
  },
});
